module.exports = __webpack_public_path__ + "assets/img/leo.b27fedce.png";